import { render, staticRenderFns } from "./MarketingHeader.vue?vue&type=template&id=2d843e3c&"
import script from "./MarketingHeader.vue?vue&type=script&lang=ts&"
export * from "./MarketingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports